<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'DynamicDomainNameList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Dynamic Domain Name
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Dynamic Domain Name</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <div class="card-header">
                <h3 class="card-title">Detail</h3>
              </div>
              <div class="card-body">
                <div class="custom-list">
                  <ul>
                    <!-- <li><strong>ID</strong> {{ value.id }}</li> -->
                    <li><strong>Audra</strong>{{ value.device_name }}</li>
                    <li>
                      <strong>Status</strong>
                      <span v-if="value.is_enable">{{
                        pre.is_enable[value.is_enable]
                      }}</span>
                    </li>
                    <li><strong>Lookup Hostname</strong>{{ value.lookup_hostname }}</li>
                    <li><strong>Service Provider</strong>{{ value.service_provider }}</li>
                    <li><strong>Domain Name</strong> {{ value.domain_name }}</li>
                    <li><strong>User Name</strong> {{ value.user_name }}</li>
                    <li><strong>Password</strong> {{ value.user_password }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import LocalStorage from "@/services/localStorage";
import { CommonAPI } from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "DynamicDomainNameShow",
  metaInfo: {
    title: "Dynamic Domain Name | Dotlines",
  },
  data: () => ({
    value: {},
    pre: {
      is_enable: ["DISABLE", "ENABLE"],
      audraName: [],
    },
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/dynamic_domain_names/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
